import { initDropdown } from "./initDropdown";

export const dropdown = {
  initDropdown
};
